import { convertUnit } from './unitConversion'
import type { UnitSystem } from './units'

type ParameterUnitsSource = {
  unit?: string | null
  imperialUnit?: string | null
  roundDigits?: number | null
  imperialRoundDigits?: number | null
}

export type UnitsInSystem = {
  unit?: string
  roundDigits?: number
  fromMetric: (metricValue: number) => number
}

const unchanged = (metricValue: number) => metricValue

export const unitsInSystem = (parameter: ParameterUnitsSource | undefined, unitSystem: UnitSystem): UnitsInSystem => {
  const unit = parameter?.unit ?? undefined
  const imperialUnit = parameter?.imperialUnit
  if (unitSystem === 'metric' || !imperialUnit) {
    return { unit, roundDigits: parameter?.roundDigits ?? undefined, fromMetric: unchanged }
  }
  return {
    unit: imperialUnit,
    roundDigits: parameter?.imperialRoundDigits ?? parameter?.roundDigits ?? undefined,
    fromMetric: (metricValue) => convertUnit(metricValue, unit, imperialUnit),
  }
}
